import React, { memo, useEffect, useState } from 'react';
import { LocationIcon, TimeIcon, BackIcon } from '../icons';
import { Colors } from '../../constants';
import moment from 'moment-timezone';
import useWindowDimensions from '../../custom_hooks/useWindowDimensions';
import { set_interval } from '../../custom_functions/interval';
import { useTranslation } from 'react-i18next';
import { hex_to_rgba } from '../../custom_functions/hex_to_rgba';
import ct from 'countries-and-timezones';

const LeftContent = memo((props) => {
  const [ displayTimeInterval, setDisplayTimeInterval ] = useState('0 min');
  const { width } = useWindowDimensions();
  const [ showBackButton, setShowBackButton ] = useState(false); // back button
  const [ showMoreDetail, setShowMoreDetail ] = useState(false); // more action detail
  const [ showDescriptionDetail, setShowDescriptionDetail ] = useState(false); // show more button for description if width > 858
  const { t } = useTranslation();

  const { 
    color,
    name,
    title,
    description,
    imageUrl,
    location,
    isReschedule,
    isConfirm,
    timeInterval,
    showTimingSelected,
    timingSelected,
    timezoneName,
    backButtonOnClick,
    isCancelMeeting,
    showTimingList,
    showForm,
    isoTime,
    currentTiming,
    locationSearch,
    isShareDateTime,
    durationOptions,
    handleChangePath,
    currentDuration
  } = props;

  useEffect(() => {
    // let time_interval = timeInterval;
    // if(time_interval > 60){
    //   time_interval = time_interval/60 + ' hours';
    // }
    // else if(time_interval === 60){
    //   time_interval = time_interval/60 + ' hour';
    // }
    // else if((time_interval < 60) && time_interval > 1){
    //   time_interval = time_interval + ' mins';
    // }
    // else{
    //   time_interval = time_interval + ' min';
    // }
    let time_interval = set_interval(timeInterval);
    if(time_interval){
      let interval_split = time_interval.split('-');
      let detail_interval = '';

      if(interval_split.length > 1){
        detail_interval = t(interval_split[1]);
      }

      time_interval = interval_split[0].concat(' ', detail_interval)
    }
    else{
      time_interval = '-';
    }
    setDisplayTimeInterval(time_interval);

    // check description
    if(description && description.length > 0) {
      setShowDescriptionDetail(true);
    }
    else {
      setShowDescriptionDetail(false);
    }
  },
  // eslint-disable-next-line
  []);

  useEffect(() => {
    let has_back = new URLSearchParams(locationSearch).has('back');
    if(width > 850){
      if ((isReschedule || isCancelMeeting) || (!showForm && !has_back)){
        setShowBackButton(false);
      }
      else {
        setShowBackButton(true);
      }
    }
    else if(showTimingList || showForm || has_back) {
      setShowBackButton(true);
    }
    else {
      setShowBackButton(false);
    }
  },
  // eslint-disable-next-line
  [width, showForm, showTimingList, locationSearch]);

  useEffect(() => {
    if(!showDescriptionDetail) {
      var left_element = document.getElementById('left-content');
      if(left_element) {
        left_element.scrollTop = left_element.scrollHeight;
      }
    }
  }, 
  [showDescriptionDetail]);

  // callback function when more action (3 dots) clicked
  const moreActionOnClick = () => {
    setShowMoreDetail(!showMoreDetail);
  };

  // callback function to show detail of description
  const moreDescription = () => {
    setShowDescriptionDetail(!showDescriptionDetail);

    var element = document.getElementById('description-detail');
    if(element) {
      element.dangerouslySetInnerHTML = description;
    }
  };

  // callback function to markup the description
  const createMarkup = () => {
    var data = description;
    if(!showDescriptionDetail || description.length <= 120 || width <= 858) {
      return { __html: data };
    }
    else if (description.length > 120){
      return { __html: `${data.substring(0, 120)}...` };
    }
  };

  // callback function to change duration
  const setSelectedDurationOption = (value) => {
    if (value) {
      let current_url = new URL(window.location.href);
      current_url.searchParams.set('duration', value);
      let current_pathname = current_url.pathname;
      let pathname = current_url.pathname.substring(0, current_pathname.length - +(current_pathname.lastIndexOf('/') === current_pathname.length-1));
      handleChangePath(`${current_url.origin}${pathname}/${current_url.search}`);
    }
  };

  if (isShareDateTime) return null;

  return(
    <div className="left" id="left-content" style={{ boxShadow: `inset -1.063rem 0 1.25rem ${hex_to_rgba(`${color || `#${Colors.primaryColor}`}`, 0.05)}`, backgroundColor: hex_to_rgba(color || `#${Colors.primaryColor}`, 0.05) }}>
        <div className="section-top">
          {( showBackButton && ((!isReschedule && !isCancelMeeting) || (isReschedule && (showTimingList || showForm)) || (isCancelMeeting && !isConfirm)) ) && (
            <div className="back-button-wrap">
              <BackIcon handleOnClick={backButtonOnClick} color={`#${Colors.blackText}`} />
            </div>
          )}
          
          <div className="name-picture">
            <div className="photo">
                <img alt="userPhoto" width={width > 858 ? '141' : '20'} height={width > 858 ? '141' : '20'} className="photo-image" src={imageUrl} />
            </div>
            <div className="profile name-event">
                <span className="name">{name}</span>
            </div>
          </div>
        </div>

        <div className="section-bottom" style={{ bottom: (isReschedule || isCancelMeeting) ? '0' : '.2rem', marginTop: (isReschedule || isCancelMeeting) ? '0' : '1rem' }}>
          <div className="row">
            <div className="profile description-event">
              <div className="title">{ title }</div>

                { timeInterval && (
                  <div className="time-interval">
                    <TimeIcon customClass={''} color={Colors.blackText} />
                    { timeInterval !== 'Ask Invitee' ?
                      (<span>{ displayTimeInterval }</span>)
                      : (
                        <div className="duration-ask-invitee">
                          { currentDuration ? (
                            <select
                              value={currentDuration}
                              onChange={e => setSelectedDurationOption(e.target.value)} >
                              { durationOptions?.content.map((data, index) => (<option key={index} value={data}>{ set_interval(data) }</option>)) }
                            </select>
                          ) : (
                            <div>Loading...</div>
                          )}
                        </div>
                      )
                    }
                  </div>
                )}
            </div>

            { width <= 858 && (location || (description && description.length > 0)) && (
              <div className="more-button-actions">
                <button
                  type="button"
                  className="button-see-more"
                  onClick={moreActionOnClick}
                  style={{ color: color }} >
                    { t(`See ${ showMoreDetail ? 'Less' : 'More' }`) }
                </button>
              </div>
            )}
          </div>

          <div className="profile description-event w-100">              
            { (width > 858 || showMoreDetail) && (
              <>
                { description && description.length > 0 && (
                  <>
                    <div className="title">{ t('Description') }</div>
                    <div className="description-event-detail">
                      <span 
                        title={description.replace(/<[^>]*>/g, "")} 
                        dangerouslySetInnerHTML={createMarkup()} 
                        className="description"
                        id="description-detail"></span>

                      { description && description.length > 120 && width > 858 && (
                        <span className="description-more">
                          <button 
                            onClick={() => moreDescription()} 
                            className="more-button" 
                            style={{ color: color, bottom: showDescriptionDetail ? 'unset' : '1rem', marginTop: showDescriptionDetail ? '0' : '1.5rem' }}>
                              { t(`Show ${ !showDescriptionDetail ? 'Less' : 'More' }`) }
                          </button>
                        </span>
                      )}
                    </div>
                  </>
                )}

                {location &&
                  <div className="location">
                    <div className="title">
                      { t('Location') }
                    </div>
                    <div className="location-detail">
                      <div className="location-icon">
                        <LocationIcon customClass={''} color={Colors.blackText} />
                      </div>
                      <div className="location-text">{location}</div>
                    </div>
                  </div>
                }
              </>
            )}
          </div>
        </div>

        { (isReschedule || isCancelMeeting) && currentTiming && (
          <div className="timing-selected previous-timing" style={{ backgroundColor: timingSelected ? 'transparent' : hex_to_rgba(color, 0.1), display: (width <= 858 && !showMoreDetail && (isReschedule || isCancelMeeting) && timingSelected) ? 'none' : 'block' }}>
            <div className="title">{ t('Previous Schedule') }</div>
            <div className="time-detail">
              { (isoTime === true) ?
                  `${moment(currentTiming).tz(timezoneName).format('HH:mm')} - ${moment(currentTiming).tz(timezoneName).add(timeInterval === 'Ask Invitee' ? currentDuration : timeInterval, 'minutes').format('HH:mm')}` :
                  `${moment(currentTiming).tz(timezoneName).format('hh:mm a')} - ${moment(currentTiming).tz(timezoneName).add(timeInterval === 'Ask Invitee' ? currentDuration : timeInterval, 'minutes').format('hh:mm a')}`
              }
            </div>
            <div className="date">
              { `${t(moment(currentTiming).tz(timezoneName).format('dddd'))}, ${moment(currentTiming).tz(timezoneName).format('DD')} ${t(moment(currentTiming).tz(timezoneName).format('MMMM'))} ${moment(currentTiming).tz(timezoneName).format('YYYY')}` }
            </div>
            <div className="timezone">
            { `${Object.values(ct.getAllTimezones()).find(x => x.utcOffset === moment(currentTiming, 'x').utcOffset()).name || '-'} (UTC${moment(currentTiming, 'x').format('Z')})` }
            </div>
          </div>
        )}

        { showTimingSelected && timingSelected && (
          <div className="timing-selected" style={{ backgroundColor: hex_to_rgba(color, 0.1), display: (width <= 858 && !showMoreDetail && timingSelected) ? 'none' : 'block' }}>
            <div className="title">
              { isReschedule ? t("New Schedule") : t("Date & Time") }
            </div>
            <div className="time-detail">
              { (isoTime === true) ?
                  `${moment(timingSelected).tz(timezoneName).format('HH:mm')} - ${moment(timingSelected).tz(timezoneName).add(timeInterval === 'Ask Invitee' ? currentDuration : timeInterval, 'minutes').format('HH:mm')}` :
                  `${moment(timingSelected).tz(timezoneName).format('hh:mm a')} - ${moment(timingSelected).tz(timezoneName).add(timeInterval === 'Ask Invitee' ? currentDuration : timeInterval, 'minutes').format('hh:mm a')}`
              }
            </div>
            <div className="date">
              { `${t(moment(timingSelected).tz(timezoneName).format('dddd'))}, ${moment(timingSelected).tz(timezoneName).format('DD')} ${t(moment(timingSelected).tz(timezoneName).format('MMMM'))} ${moment(timingSelected).tz(timezoneName).format('YYYY')}` }
            </div>
            <div className="timezone">
              { timezoneName }
            </div>
          </div>
        )}
    </div>
  );
});

export default LeftContent;